import * as popularRolesAdditionalComponents from "@/components/PopularRolesPage";
import * as simplePagesAdditionalComponents from "@/components/SimplePage";
import { getPopularRolesStaticProps } from "@/functions/getPopularRolesStaticProps";
import { getSimplePagesStaticProps } from "@/functions/getSimplePagesStaticProps";
import { pages_helper } from "@/helpers/pages_helper";
import { popular_roles_helper } from "@/helpers/popular_roles_helper";
import { Content } from "@/ui/Content";

//Page Builder Components
import dynamicPages from "@/../.sourceflow/dynamic_pages.json";
import { getDynamicPageStaticProps } from "@/functions/getDynamicPageStaticProps";
import { BuilderContentBlocks } from "@/ui/BuilderContentBlocks";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";

export default function SimpleOrPopularRolesPage({ prefix, title, seo, canonical, data, isBuilder, content }) {
  return isBuilder ? (
    <>
      <DynamicPageSeo
        {...seo}
        title={seo?.title.length > 0 ? seo.title : title}
        canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
      />
      <BuilderContentBlocks data={data} prefix={prefix} />
    </>
  ) : (
    <Content
      items={content}
      additionalComponents={{
        ...simplePagesAdditionalComponents,
        ...popularRolesAdditionalComponents,
      }}
    />
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const [url_slug] = url_slugs;
  const builder_url_slug = url_slugs.join("/");
  const builderPage = dynamicPages.find((i) => i.url_slug === builder_url_slug);
  if (builderPage) {
    return getDynamicPageStaticProps({ page: builderPage, url_slug : builder_url_slug });
  }

  if (popular_roles_helper.find(url_slug)) {
    return getPopularRolesStaticProps(url_slug);
  }

  return getSimplePagesStaticProps(url_slugs);
}

export async function getStaticPaths() {
  // adds page builder
  const builderPaths = dynamicPages
    .filter((i) => !["/"].includes(i.url_slug))
    .map((i) => ({ params: { url_slugs: i.url_slug.split("/") } }));

  return {
    paths: [
      ...builderPaths,
      ...pages_helper.toNestedPaths(),
      ...popular_roles_helper.toNestedPaths(), // These don't use nested in CMS, using this method for template purposes only
    ],
    fallback: false,
  };
}
